import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const CarouselComponent = React.lazy(() => import("../Components/RootComponents/CarouselComponent"));
const CarouselPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <CarouselComponent />
      </Suspense>
    </Fragment>
  );
};

export default CarouselPage;
